import { createGlobalStyle } from 'styled-components'
import { mq } from './mq'
import { theme } from './theme'

export const GlobalStyle = createGlobalStyle`
:root {
  --header-height: 6.4rem;
  --color: #1a3948;
  --color-primary: #FF5400;
  --background: #F8F7F6;
}

html {
  height: 100%;
  font-size: 62.5%;
}

body {
  margin: 0;
  overflow-x: hidden;
  font-family: ${theme.fonts.base},
    sans-serif;
  height: 100%;
  color: var(--color);
  font-size: 1.6rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-tap-highlight-color: transparent;
  background-color: var(--background);

  ${mq.medium} {
    font-size: 2rem;
  }

  ${mq.large} {
    font-size: 2.3rem;
  }
}

*, *::before, *::after {
  box-sizing: border-box;
}

body.locked {
  overflow: hidden;
}

#root {
  display: flex;
  flex-direction: column;
  min-height: 100%;

  > * {
    flex-shrink: 0;
  }
}

a {
  color: var(--color-primary);
  text-decoration: none;
}

.underline a {
  border-bottom: 1px solid currentColor;

  &:hover, &:focus {
    border-bottom-color: transparent;
  }
}
`
